const Colors = {
  // backgroundColor: "#ebf1f3",
  backgroundColor: "#EFF4F5",
  bubbleColor: "#3f7b8d",
  grayColor: "#9c9c9cff",
  bodyweightColor: "#5DC460",
  tracColor: "#C263F9",
  blackColor: "#000000",
  whiteColor: "#FFFFFF",
  darkgrayColor: "#4b5563",
  lightGrayColor: "#f2f2f2",
  noteColor: "#e2c136",
  warningBackgroundColor: "rgba(255, 167, 38, 0.18)",
  warningTextColor: "#C2410C",
  redColor: "rgb(240, 68, 56)",
  hoveredGray: "#f5f5f5",
  sideMenuColor: "#1E1E1E",
  borderColor: "rgb(218, 218, 218)",
  messageLightColor: "#C7C7CC",
  messageBubbleColor: "#33687C",
  mediumGray: "#5E5E5E",
  carbsColor: "#FFA726",
  proteinColor: "#43A047",
  fatsColor: "#F76C6C",
  carbsMyFitnessPal: "#2cb7ae",
  proteinMyFitnessPal: "#feb13d",
  fatsMyFitnessPal: "#c576e1",
  competitionColor: "#CB3534",
  darkBubbleColor: "#2E5E6E",
};

//RGBA BUBBLE COLOR -> "rgba(63, 123, 141, 0.1)"

export default Colors;
